import warning from 'warning';
import submitAndCollateErrors from './submitAndCollateErrors';

export default function submit(values, dispatch, props) {
    warning(true, 'submit() has been deprecated and will be removed in the next major version - Please update to use submitAndCollateErrors instead');
    return submitAndCollateErrors(values, dispatch, props);
}
